import { render, staticRenderFns } from "./loginform.vue?vue&type=template&id=5a8a2bdb&scoped=true&"
import script from "./loginform.vue?vue&type=script&lang=js&"
export * from "./loginform.vue?vue&type=script&lang=js&"
import style0 from "./loginform.vue?vue&type=style&index=0&id=5a8a2bdb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8a2bdb",
  null
  
)

export default component.exports